import services from './../services/service'; // Service Class
import setts from './setts.js'; //varying settings
let service = new services();

export default {
    name: 'PaymentsAndUpdates',
    mixins: [setts],
    data () {
      return {
        is_logged_in:false,
        payment_set_amount: 500,
        payment_process_option: 0, //default
        //payment_data:{},
        payment_status: 0,
        callback_url:"",
        // data_processing_message: "",
        paymentModalComponentKey:0,
        today: new Date,
      }
  },

    methods: {
        setPaymentOption(option){
            this.payment_process_option = option;  
            if((this.payment_data.total_amount) && (this.payment_data.total_amount > 0)){
                //call cnpayment methods
                if(this.payment_process_option == 1){
                    this.processCNpaymentByGateway();
                }else if(this.payment_process_option == 2){
                    this.processCNpaymentWithWallet();
                }
            }
        },
        
        //DIRECT TO MIXIN make cninsurance payment
        processCNpaymentByGateway() {
            let self = this;
            let gateway_pub_key = service.ravepay_public_live_paga; //use as default api public key
            //#updates with varying 
            if(this.payment_data.payment_ravepay_pub_key != ''){
                gateway_pub_key = this.payment_data.payment_ravepay_pub_key;
            }
            //uncmt...paga ravepay payment 
            var x = getpaidSetup({
                // PBFPubKey: service.ravepay_public_test, //test //devlot
                PBFPubKey: gateway_pub_key,//service.ravepay_public_live_paga, //api public key
                customer_email: this.payment_data.customerEmail, // "mail@gmail.com"
                amount: this.payment_data.total_amount,
                customer_phone: this.payment_data.customerPhoneNumber, //"234099940409"
                currency: "NGN",
                payment_method: "both",
                // txref: "CNpayPG-"+this.today.getTime(),
                txref: this.payment_data.payment_ref, //use for random testing purposes
                subaccounts: this.payment_data.payment_subaccounts,
                meta: this.payment_data.payment_meta,
                onclose: function() {
                    setTimeout(function (){
                        //DEPRAC CASE:X02
                        // self.reset(); 
                    }, 20000);
                },
                callback: function(response) {
                    var txref = response.tx.txRef; // collect flwRef returned and pass to a server page to complete status check.
                    var tx_amount = response.tx.amount;
                    if (
                        response.tx.chargeResponseCode == "00" ||
                        response.tx.chargeResponseCode == "0"
                    ) {
                        self.processing = true;
                        self.data_processing_message = "Payment made, Processing Data Update";
                        //uncmt...paga ravepay payment 

                        //uncmt...server validation
                        //server validation
                        // let payload =
                        // {
                        //    "SECKEY": service.ravepay_secret_live_paga, //use API secret key
                        //     "txref": txref
                        // };
                        // service.verifyRavePayment(self, payload).then(response => {
                        //     // console.log(response); // 42
                        //     // console.log(response.body.data.status); // 42
                        //     if ((response.body.data.status === "successful") && (response.body.data.chargecode == "00")) {
                        //         //check if the amount is same as amount you wanted to charge just to be very sure
                        //         self.payment_message = "Payment processed successfully."
                                
                        //         if (response.body.data.amount === tx_amount) {
                        //     //uncmt...server validation
                        //             //enter into db
                        //             //UNCMT 
                        //             let txref = "CNpayPG-"+self.today.getTime();
                        //             let tx_amount = self.total_fee;
                        //             //UNCMT 
                                    let txn_payload = {
                                        "transaction_payment_ref": txref,
                                        "transaction_module": self.payment_data.transaction_module,
                                        "transaction_module_id": self.payment_data.transaction_module_id,
                                        "transaction_type": self.payment_data.transaction_type,
                                        "transaction_mode": 1, //payment gateway
                                        "transaction_mode_transaction_ref":txref, //use here still
                                        "transaction_amount_paid": tx_amount,
                                        "payer_name": self.payment_data.customerName || "Nil",
                                        "payer_email":self.payment_data.customerEmail, 
                                        "payer_phone": self.payment_data.customerPhoneNumber,
                                        "payer_user": self.user.user_id || 0,
                                    };
                                    //post
                                    self.postCNpaymentDetails(txn_payload);
                        //         //uncmt...server validation
                        //         }
                        //     }
                           
                            
                        // }).catch((err) => {})
                        //uncmt...//....server validation
                    //uncmt...paga ravepay payment 
                    } else {
                        // redirect to a failure page.
                        self.payment_message = service.service_payment_failed;
                        self.resetPaymentStats();
                        // self.afterProcessing(1,service.service_payment_failed);
                    }
                }
            });
        },

        processCNpaymentWithWallet(){
            let tx_amount = this.payment_data.total_amount;
            let tx_ref = this.payment_data.payment_ref;
            //
            var payload ={
                pay: this.user.user_id, // 
                txn_amount: tx_amount,
                service: this.payment_data.transaction_service, //from cn_services
                service_ref: tx_ref
            }
            let test_mode = false;
            if(test_mode){
                console.log("test_mode: chilling here");
            }else{
                let self = this;
                service.postWalletPayout(this, payload).then(response => {
                    if(response.body.status == 201) {
                        var txref = response.body.data_txn_ref;
                        let txn_payload = {
                            "transaction_payment_ref": self.payment_data.payment_ref,
                            "transaction_module": self.payment_data.transaction_module,
                            "transaction_module_id": self.payment_data.transaction_module_id,
                            "transaction_type": self.payment_data.transaction_type,
                            "transaction_mode": 2, //CNrewards-Wallet
                            "transaction_mode_transaction_ref":txref, //use here
                            "transaction_amount_paid": tx_amount,
                            "payer_name": self.payment_data.customerName || "Nil",
                            "payer_email":self.payment_data.customerEmail, 
                            "payer_phone": self.payment_data.customerPhoneNumber,
                            "payer_user": self.user.user_id || 0,
                        };
                        //post
                        self.postCNpaymentDetails(txn_payload);
                    }else{
                        this.payment_message = service.service_payment_failed;
                        this.resetPaymentStats();
                        // this.afterProcessing(1,service.service_payment_failed);
                    }
                }).catch((err) => {
                    if(err) {
                        this.resetPaymentStats();
                        ///--REFLOW-----//toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }
        },

        postCNpaymentDetails(txn_payload){
            let self = this;
            service.postCNpaymentDetails(self,txn_payload).then(response => {
                // let message = response.body.message;
                //format if object returned ed {}
                let message = response.body.message; 
                message = message.replace('{', '');
                self.payment_process_option = 0;
                if(response.body.status == 200){
                    self.payment_status = 200;
                    self.data_processing_message = service.service_payment_circle_fully_successful;
                    //set-moda-msg
                    localStorage.setItem("payment_modal_message",self.data_processing_message);   
                }else if(response.body.status == 400){
                    self.payment_status = 400;
                    self.data_processing_message = service.service_payment_circle_not_fully_successful+'\nIssue: '+message;
                    //set-moda-msg
                    localStorage.setItem("payment_modal_message",self.data_processing_message);
                    localStorage.setItem("reslove_issues",message);
                 }
                //self.afterPostPayment(respose.body.data);
                //x.close(); // use this to close the modal immediately after payment.
            }).catch((err) => {
                // console.log(err)
            })
        },

        afterPostPayment(data){
            if((data.data_callback_url) && (data.data_callback_url)){
                //set cal bck
                //if no btn prompt
                this.$router.push(this.callback_url);
            }
        },

        resetPaymentStats(){
            this.payment_process_option = 0; //free//resets
        },

        resetPaymentEvents(){
            //usually called if the activities wre not used
            localStorage.removeItem("payment_modal_message");
            localStorage.removeItem("reslove_issues");
            localStorage.removeItem("reslove_issues_for");
        }
        
    },
    created: function(){}
}


// WEBPACK FOOTER //
// ./src/mixins/payments_and_updates.js